/**
 * @desc queryMsgByTimestamp
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 云信会议房间ID */
  channelId?: number;
  /** 查询条数（如果时间戳相同，可能存在返回条数大于size的情况） */
  size?: number;
  /** 时间戳，从当前时间戳往前查（不包括当前时间戳） */
  timestamp?: number;
}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/v3/meeting/transcription/msg/query',
      params,
      'POST',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/transcription/msg/query',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/v3/meeting/transcription/msg/query',
      params,
      'POST',
    ),
    {
      method: 'POST',

      ...options,
    },
  );
}
